var factsheetHeader = {
	label: {
		highLowBar: "Rango intradiario",
		lastPriceDateTime: "Fecha/Hora:",
		volume: "Volumen:",
		isin: "ISIN",
		wkn: "WKN",
		numberOfConstituents: "Número de Constituyentes",
		country: "País",
		symbol: "Símbolo",
		fundIssuer: "Emisor",
		fundCategory: "Categoría",
		pea: "Plan de Ahorro Compartido",
		pme: "Plan de Ahorro Compartido-Pymes",
		srd: "Directiva Sobre Derechos de los Accionistas",
		tradingStatus: "Estado de la Negociación",
		perf1Year: "Rend. 1 Año",
		perf5Years: "Rend. 5 Años",
		perf1Week: "Rend. 1 Semana",
		perf1Month: "Rend. 1 Mes",
		suspended: "Suspendido",
		marketStatus: "Estado del Mercado",
		tradingPhase: "Fase de Negociación",
		expectedDividends: "Dividendos Esperados",
		expectedPriceEarningsRatio: "Ratio P/B Esperado"
	},
	"true": "Sí",
	"false": "No",
	open: "Abierto",
	close: "Cerrado"
};
var es = {
	factsheetHeader: factsheetHeader
};

export { es as default, factsheetHeader };
